module.exports = __webpack_public_path__ + "img/coupon_tutorial_gimmi02.7b64ccc9.png";